/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/23
 * @updateTime 2021/8/23
 * @decription
 */
import {columnsDBFS, columnsDycclx} from "@/utils/option";
import {createId} from '@/utils/common';
import MB from "@/utils/download";
// 表单处理
import formHandler from '../mixins/formHandler.js';
import {
    bcdbyyRule,
    dzdbsRule
} from "@/utils/validator/rules";
import validate from "@/utils/validator/validator";

export default {
    name: 'app-supplement-dbxx',
    // 混入
    mixins: [formHandler],
    components: {},
    props: {
        // 是否只读，如果是查看则是只读
        readonly: Boolean
    },
    data() {
        return {
            // 私有属性
            scope: {
                // class前缀
                prefixCls: 'fd-supplement-dbxx'
            },
            formData: {
                // 如果是新增进入页面调用接口生成，否则从data中获取
                cId: '',
                // 补充担保原因
                cSqbgyy: '',
                // 担保方式
                cDbfs: columnsDBFS[0].keyId,
                // 担保方式文字描述
                dbfsText: columnsDBFS[0].text,
                // 诉责险id，担保方式为诉责险并且是系统自动关联中表单提交的时候会用到
                cSzxid: '',
                // 是否系统自动关联担保
                nSysbuy: 1,
                // 担保机构id
                cBxgs: '',
                // 担保机构名称
                cBxgsmc: '',
                // 保单号
                cBdh: '',
                // 担保价值
                nDbjz: '',
                // 担保价值文本
                nDbjzText: '',
                // 担保说明
                cDbsm: '',
                // 担保人
                cDbr: '',
                // 担保物名称
                dBwmc: '',
                // 抵押/质押财产类型,
                cCclx: '',
                // 财产类型文字描述
                cCclxText: '',
                // 上传材料信息
                tBqSqcls: [],
                // 是否添加
                isAdd: true
            },
            // 申请人姓名
            sqr: '',
            //担保机构弹层
            showPickerBxgs: false,
            // 担保机构数据
            columnsBxgs: this.dataList,
            // 保单号弹层
            showPickerBdh: false,
            // 保单号
            columnsBdh: [],
            // 担保方式
            // columnsDBFS: columnsDBFS,
            columnsDBFS: [],
            // 担保方式选择器
            showPickerDbfs: false,
            showPickerDycclx: false, // 抵押财产类型
            columnsDycclx: columnsDycclx,
            bdhInfo: [],
            MB: MB,
            // 是否新增
            isAdd: true,
            // 文件上传url地址
            uploadFileUrl: 'ssbq/api/sccls/bgdb/sccl',
            // 删除文件请求url地址
            deleteFileUrl: 'ssbq/api/sccls/bgsq/bg/delsccl'
        };
    },
    computed: {
        // 上传文件参数
        uploadFileParam() {
            return {
                // 保全id
                bqid: this.bqid,
                // 担保id
                dbid: this.formData.cId,
                tjid: '',
                // 材料类型
                cllx: '4',
                sqslx: '4'
            }
        }
    },
    methods: {
        /**
         * 获取删除文件的参数
         * @param {Object} fileData 文件数据
         * @returns {Object} 请求参数对象
         * */
        getDeleteFileParam(fileData) {
            return {
                // 请求id
                id: fileData.cSqclid,
                // 材料类型
                cllx: '4'
            }
        },
        /**
         * 获取上传文件数据
         * @returns {Object} 文件数据
         * */
        getUploadFileData(data, fileData) {
            return {
                // 申请材料id
                cSqclid: data.fileId,
                ...fileData
            };
        },

        /**
         * 抵押财产类型
         * @param {Object} item 选择的信息项数据
         * @returns {void}
         * */
        onConfirmDycclx: function (item) {
            this.formData.cCclxText = item.text;
            this.formData.cCclx = item.keyId;
            this.showPickerDycclx = false
        },

        /**
         * 请求id
         * @returns {void}
         * */
        initDbid: function () {
            // 创建id
            createId().then(id => {
                this.formData.cId = id;
            });
        },

        /**
         * 删除相关材料
         * */
        deleteFiles() {
            // 调用删除变更担保申请材料接口
            this.requestDelSccl({
                cDbid: this.formData.cId,
                isDeldbl: true,
                isDelsqs: false,
                cBgid: ''
            }).then(() => {
                // 担保材料置空
                this.formData.tBqSqcls = [];
            }).catch(error => {
                console.log(error);
            });
        },

        /**
         * 校验表单数据
         * */
        validateFormDate: function () {
            var descriptor = {
                // 担保原因
                cSqbgyy: bcdbyyRule
            };
            // 公共校验部分
            this.commonValidateForm(descriptor);
            // 如果是非保险公司诉责险并且自动关联，担保材料必填
            if (!(this.formData.cDbfs == 5 && this.formData.nSysbuy === 1)) {
                // 担保材料校验
                descriptor.tBqSqcls = dzdbsRule;
            }
            // 校验表单数据
            const validated = validate(descriptor, this.formData);
            return validated;
        },

        /**
         * 初始化数据
         * */
        initData() {
            // 申请人姓名通过url参数中获取
            let source = this.source;
            // 赋值申请人姓名
            this.sqr = source.sqrXm;
            // 行为保全和证据保全担保方式不显示【保险公司诉责险】
            let cBqlx = sessionStorage.getItem('cBqlx');
            let cBqlb = sessionStorage.getItem('cBqlb');
            if (cBqlx === '1' && cBqlb !== '4') {
                this.formData.cDbfs = '5';
                this.formData.nSysbuy = 1;
                this.columnsDBFS = columnsDBFS;
            } else {
                this.formData.cDbfs = '1';
                this.formData.nSysbuy = null;
                this.columnsDBFS = columnsDBFS.filter(item => item.keyId !== '5');
                this.formData.dbfsText=columnsDBFS.filter(item=>item.keyId==='1')[0].text;
            }
            // 如果当前data没有数据，则属于新增
            this.isAdd = !this.data;
            // 如果是新增，则需要获取担保id
            if (this.isAdd) {
                // 初始化担保id，文件上传、保存的时候需要用到
                this.initDbid();
            }
        },
        /**
         * 组装表单数据
         * @returns {void}
         * */
        assembleFormData() {
            if (this.isAdd) {
                return;
            }
            // 公共组装个表单数据
            this.commonAssembleFormData();
        },

        /**
         * 初始化方法
         * @returns {void}
         * */
        init() {
            // 初始化数据
            this.initData();
            // 组装表单数据
            this.assembleFormData();
        }
    },
    created() {
        // 初始化方法
        this.init();
    }
}
